import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { AccountInfoComponent } from '@shared/account-info/account-info.component';
import { RavIcon } from '@shared/icon/icon';
import { LocalStorageService } from '@shared/services/local-storage.service';
import { TokenService } from '@shared/services/token.service';
import { NgxZendeskWebwidgetService } from 'ngx-zendesk-webwidget';

@Component({
  selector: 'rav-account-dropdown',
  templateUrl: './account-dropdown.component.html',
  styleUrls: ['./account-dropdown.component.scss']
})
export class AccountDropdownComponent extends AccountInfoComponent {
  RavIcon = RavIcon;

  constructor(
    localStorage: LocalStorageService,
    token: TokenService,
    router: Router,
    zenDesk: NgxZendeskWebwidgetService
  ) {
    super(localStorage, token, router, zenDesk);
  }
}
